import React from 'react';
import { CalendarDaysIcon, CarIcon, ExternalLinkIcon, MapPinIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ADDRESS, MAPS_EMBED_URL, MAPS_URL } from '../data/seminar';
const blocks = [{
  icon: CalendarDaysIcon,
  title: 'Fecha y hora',
  text: 'Sábado 15 de Agosto, 2026 · 10:30 AM'
}, {
  icon: MapPinIcon,
  title: 'Lugar',
  text: ADDRESS
}, {
  icon: CarIcon,
  title: 'Cómo llegar',
  text: 'Fácil acceso · Estacionamiento disponible · Walking distance'
}];
export function EventDetails() {
  return <section id="detalles" className="w-full bg-cream-dark py-20 sm:py-28" data-id="element-32" data-mp="28mygtl27pxi3">
      <div className="mx-auto max-w-6xl px-6" data-id="element-33" data-mp="28ku3kcifbm55">
        <div className="mx-auto max-w-2xl text-center" data-id="element-34" data-mp="24ktnknfof2vz">
          <span className="section-label" data-id="element-35" data-mp="24nfy8vxv5yif">Te esperamos</span>
          <h2 className="mt-5 font-serif text-4xl font-light leading-tight text-navy sm:text-5xl" data-id="element-36" data-mp="3k126if1rozhc">
            Detalles del Evento
          </h2>
          <div className="mx-auto mt-7 h-px w-16 bg-gold" aria-hidden="true" data-id="element-37" data-mp="3g2uqjmf4o277" />
        </div>

        <ul className="mt-14 grid gap-6 sm:grid-cols-3" data-id="element-38" data-mp="5t2kt4d193c5">
          {blocks.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="rounded-2xl bg-cream p-8 shadow-soft" data-id="element-39" data-mp="ereh9n0kyvci">
              <Icon className="h-7 w-7 text-gold" strokeWidth={1.25} aria-hidden="true" data-id="element-40" data-mp="epbncrwb4i2i" />
              <h3 className="mt-5 font-sans text-[10px] font-semibold uppercase tracking-[0.24em] text-gold" data-id="element-41" data-mp="jpprhyusf7v9">
                {title}
              </h3>
              <p className="mt-3 font-serif text-xl font-medium leading-snug text-navy" data-id="element-42" data-mp="3n6g5p10iwr81">{text}</p>
            </li>)}
        </ul>

        <div className="mt-12 overflow-hidden shadow-soft" style={{
        borderRadius: '12px'
      }} data-id="element-43" data-mp="3s4zquz7alyzc">
          <iframe title="Mapa del lugar del seminario: 3033 Excelsior Blvd, Suite 100, Minneapolis, MN 55416" src={MAPS_EMBED_URL} width="100%" height="350" style={{
          border: 0,
          display: 'block'
        }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen data-id="element-44" data-mp="t7x19ok0tvb" />
        </div>

        <div className="mt-5 text-center" data-id="element-45" data-mp="6mn934scmgc7">
          <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-gold transition-opacity hover:opacity-75" data-id="element-46" data-mp="kejuyr3fbu05">
            Abrir en Google Maps
            <ExternalLinkIcon className="h-3.5 w-3.5" strokeWidth={1.5} aria-hidden="true" data-id="element-47" data-mp="3ju84uy0dyb43" />
          </a>
        </div>

        <div className="mt-14 text-center" data-id="element-48" data-mp="1p50xgm5o559">
          <CtaButton size="lg" data-id="element-49" data-mp="1lphy2pd2byk">Reserva tu lugar por WhatsApp</CtaButton>
        </div>
      </div>
    </section>;
}